/*
 * Produktbuehne "Ebenen": Tiefenbewegung beim Scrollen.
 * Das Wort hinten bleibt am staerksten zurueck, das Produkt etwas, die
 * Bedienung vorn laeuft normal mit. Wie weit, steht als --sinken im Stylesheet
 * (theme-build/teile/ebenen.css, Anteil der eigenen Hoehe).
 *
 * Kann der Browser Scroll-Animationen in CSS, bewegt er beides selbst (ebenen.css;
 * auf dem iPhone ruckelfrei). Sonst fuehrt dieses Skript nach, aber nur mit Maus
 * oder Trackpad; auf Touch-Geraeten ohne Scroll-Animation steht die Buehne still.
 * Die Bewegung ist AN den Scroll gebunden (kein Ausloesen, kein Nachlaufen) und
 * schreibt nur transform. Farbwahl und Layout brauchen dieses Skript nicht.
 */
(function () {
  'use strict';

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var touch = window.matchMedia('(hover: none) and (pointer: coarse)');
  /* dieselbe Bedingung wie das @supports in ebenen.css */
  var cssScroll = !!(
    window.CSS &&
    CSS.supports &&
    CSS.supports('animation-timeline: view()') &&
    CSS.supports('animation-range: exit-crossing 0% exit-crossing 100%')
  );
  var aktiv = [];

  /* --sinken eines Elements in Prozent seiner Hoehe */
  function sinken(el) {
    return el ? parseFloat(window.getComputedStyle(el).getPropertyValue('--sinken')) || 0 : 0;
  }

  function einrichten(sektion) {
    if (sektion.hasAttribute('data-ebenen-bereit')) return;
    sektion.setAttribute('data-ebenen-bereit', '');

    var wort = sektion.querySelector('[data-ebene-wort]');
    var produkt = sektion.querySelector('[data-ebene-produkt]');
    var imEditor = window.Shopify && window.Shopify.designMode;
    var eintrag = { sektion: sektion, aufraeumen: function () {} };
    aktiv.push(eintrag);

    /* Im Theme-Editor: den angewaehlten Farb-Block zeigen */
    function beiBlock(e) {
      var bild = e.target.closest ? e.target.closest('[data-farbe-bild]') : null;
      if (!bild || !sektion.contains(bild)) return;
      var feld = sektion.querySelector('[data-farbwahl="' + bild.getAttribute('data-farbe-bild') + '"]');
      if (feld) feld.checked = true;
    }
    document.addEventListener('shopify:block:select', beiBlock);

    if (cssScroll || touch.matches || wenigBewegung.matches || imEditor || (!wort && !produkt)) {
      eintrag.aufraeumen = function () { document.removeEventListener('shopify:block:select', beiBlock); };
      return;
    }

    var WORT = sinken(wort);
    var PRODUKT = sinken(produkt);
    var geplant = false;
    var imBlick = true;

    function zeichnen() {
      geplant = false;
      var r = sektion.getBoundingClientRect();
      /* 0 = Hero steht oben an, 1 = Hero ist ganz hinausgescrollt */
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
      if (wort) wort.style.transform = 'translate3d(0,' + (p * WORT).toFixed(2) + '%,0)';
      if (produkt) produkt.style.transform = 'translate3d(0,' + (p * PRODUKT).toFixed(2) + '%,0)';
    }
    function beiScroll() {
      if (!imBlick || geplant) return;
      geplant = true;
      window.requestAnimationFrame(zeichnen);
    }

    var beobachter = null;
    if ('IntersectionObserver' in window) {
      beobachter = new IntersectionObserver(function (e) {
        imBlick = e[0].isIntersecting;
        if (imBlick) beiScroll();
      });
      beobachter.observe(sektion);
    }
    window.addEventListener('scroll', beiScroll, { passive: true });
    window.addEventListener('resize', beiScroll, { passive: true });
    zeichnen();

    eintrag.aufraeumen = function () {
      window.removeEventListener('scroll', beiScroll);
      window.removeEventListener('resize', beiScroll);
      document.removeEventListener('shopify:block:select', beiBlock);
      if (beobachter) beobachter.disconnect();
    };
  }

  function start(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-ebenen]');
    for (var i = 0; i < liste.length; i++) einrichten(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    aktiv = aktiv.filter(function (eintrag) {
      if (!e.target.contains(eintrag.sektion)) return true;
      eintrag.aufraeumen();
      return false;
    });
  });
})();
